import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whole-update-page" }
const _hoisted_2 = { class: "update-box" }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_4 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("b", null, "Send updates?", -1)),
        _createElementVNode("p", null, "You’ve updated " + _toDisplayString(_ctx.numberOfGuests) + " reservations. Are you ready to send updates?", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnToParent()))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "update-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickUpdate()))
        }, "Send updates")
      ])
    ]),
    _createElementVNode("div", {
      class: "overLay",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.returnToParent()))
    })
  ]))
}